export default __webpack_public_path__ + "static/media/laptop.45a3bd2a.jpeg";